define('modules/form_editor/views/editor_custom_google_recaptcha',['require','exports','module','base/view','../../editor/models/editorstate','../config','ldsh!../templates/editor_custom_google_recaptcha'],function(require,exports,module){
  "use strict";
  var BaseView = require("base/view"),
      EditorState = require("../../editor/models/editorstate"),
      CaptchaConfig = require("../config");

  var GoogleCaptchaButtonEditorView = BaseView.extend({
    template: require("ldsh!../templates/editor_custom_google_recaptcha"),
    siteKey: null,

    initialize: function () {
      this.siteKey = CaptchaConfig.googleRecaptcha.getSiteKey();

      module.exports.__super__.initialize.apply(this, arguments);
    },

    events: {
      "change .js-recaptcha-site-key": "updateSiteKey"
    },

    helpers: function() {
      var data = this.model.toJSON();

      return {
        siteKey: data.siteKey,
        isAMP: EditorState.getAMPState()
      };
    },

    updateSiteKey: function(e){
      e.preventDefault();
      var value = $(e.currentTarget).val();

      this.model.set('siteKey', value);
    },

    onRender: function() {
      this.$el.i18n();
    }
  });

  module.exports = GoogleCaptchaButtonEditorView;
});

